import { Api } from '../api';
import { accounts } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  GetCardAccountBalanceReportRequest,
  CardAccountBalanceReportResponse,
  AccountRequest,
  AccountResponse,
  AccountByIdResponse,
  AccountUpdateDetailsRequest,
  PaymentAccountBalanceReportResponse,
  GetPaymentAccountBalanceReportRequest,
  AccountForIntegrationsRequest,
  AccountForIntegrationsResponse,
  TransactionsWithPaymentsRequest,
  TransactionsWithPaymentsResponse,
} from './models';

export class AccountsApi extends Api {
  static getAccounts = (request?: AccountRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<AccountResponse[]>>({ url: accounts.getAccounts(), queryParams: request, signal });

  static getAccount = (accountId: number, signal?: AbortSignal) =>
    this.get<ApiResponse<AccountByIdResponse>>({ url: accounts.getAccountById(), queryParams: { accountId }, signal });

  static getAccountsForIntegrations = (request?: AccountForIntegrationsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<AccountForIntegrationsResponse[]>>({ url: accounts.getAccountsForIntegrations(), queryParams: request, signal });

  static getCardAccountBalanceReport = (request: GetCardAccountBalanceReportRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<CardAccountBalanceReportResponse[]>>({ url: accounts.getCardAccountBalanceReport(), queryParams: request, signal });

  static getPaymentAccountBalanceReport = (request: GetPaymentAccountBalanceReportRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<PaymentAccountBalanceReportResponse[]>>({ url: accounts.getPaymentAccountBalanceReport(), queryParams: request, signal });

  static updateDetails = (request: AccountUpdateDetailsRequest, signal?: AbortSignal) =>
    this.put<AccountUpdateDetailsRequest, ApiResponse<AccountByIdResponse>>({ url: accounts.updateDetails(), data: request, signal });

  static getTransactionsWithPayments = (request: TransactionsWithPaymentsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<TransactionsWithPaymentsResponse[]>>({ url: accounts.getTransactionsWithPayments(), queryParams: request, signal });
}
